﻿import { Loader2 } from "lucide-react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuthenticatedMe } from "@/features/organizers/api";
import { DashboardShell } from "@/components/dashboard-shell";

/**
 * Authenticated sayfalar için kısayol wrapper.
 * /me çağrısını yapıp DashboardShell'e companyName + role veriyor.
 * 401'de useAuthenticatedMe zaten /login'e yönlendiriyor.
 *
 * Gate rolü dashboard sayfalarına erişemez — `/check-in` PWA'sına redirect olur.
 */
export function DashboardPage({ children }: { children: React.ReactNode }) {
  const { data, isLoading } = useAuthenticatedMe();
  const location = useLocation();

  if (isLoading || !data) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (data.role === "Gate" && !location.pathname.startsWith("/check-in")) {
    return <Navigate to="/check-in" replace />;
  }

  return (
    <DashboardShell companyName={data.companyName} role={data.role}>
      {children}
    </DashboardShell>
  );
}
